import type { ComputedRef, InjectionKey } from 'vue'
import { NdsTagColor } from '@/components/NewDesignSystem/NdsTag/NdsTag.interfaces'
import {
  ActionStatus,
  ActionPlanDisplayViews,
  type GetActionFilterResponse,
  type ActionFilters,
} from '@/contexts/action-plans/ActionPlans.interfaces'

export const ACTION_PLANS_ROUTE_NAME = 'actions'
export const ACTION_PLAN_ROUTE_NAME = 'actionlog'
export const ACTION_PLAN_LABEL_ROUTE_NAME = 'actionlog_label'

export const ACTION_STATUS = {
  ...ActionStatus,
}

export const ACTION_PLANS_DISPLAY_VIEWS = {
  LIST: 'list',
  WORKLOAD: 'workload',
  LABELS: 'labels',
}

export const ACTION_PLAN_DISPLAY_VIEWS = {
  ...ActionPlanDisplayViews,
}

export const ACTION_PLAN_ALL_ID = 'all'

export const ACTION_PLAN_GANTT_ACTION_LIMIT_DRAG_N_DROP = 1000

// Gantt does not have pagination but the backend enforces a default per_page value.
// Using a high value as a workaround until the backend provides a dedicated filtered Gantt endpoint.
export const ACTIONS_GANTT_SEARCH_PER_PAGE = 100000

export const ACTIONS_GANTT_QUERY_PARAMS = {
  finished: '1',
  cancelled: '1',
}

export const ACTION_STATUS_TAG_COLOR: Readonly<Record<ActionStatus, NdsTagColor>> = {
  [ACTION_STATUS.TO_PLAN]: NdsTagColor.WARNING,
  [ACTION_STATUS.PLANNED]: NdsTagColor.SECONDARY,
  [ACTION_STATUS.ONGOING]: NdsTagColor.PRIMARY,
  [ACTION_STATUS.STANDBY]: NdsTagColor.NEUTRAL,
  [ACTION_STATUS.TO_REVIEW]: NdsTagColor.PRIMARY_100,
  [ACTION_STATUS.FINISHED]: NdsTagColor.SUCCESS,
  [ACTION_STATUS.CANCELLED]: NdsTagColor.NEUTRAL,
}

export const ACTION_STATUS_TRANSLATION_KEY: Readonly<Record<ActionStatus, string>> = {
  [ACTION_STATUS.TO_PLAN]: 'action.status.to_plan',
  [ACTION_STATUS.PLANNED]: 'action.status.planned',
  [ACTION_STATUS.ONGOING]: 'action.status.ongoing',
  [ACTION_STATUS.STANDBY]: 'action.status.standby',
  [ACTION_STATUS.TO_REVIEW]: 'action.status.to_review',
  [ACTION_STATUS.FINISHED]: 'action.status.finished',
  [ACTION_STATUS.CANCELLED]: 'action.status.cancelled',
}

export const MAX_ACTIONS_DISPLAY_JIRA = 300

export const ACTIONS_PER_PAGE = 20

export const ACTION_PLAN_IMPORT_EXPORT = {
  XLS_IMPORT: 'xls_import',
  XLS_EXPORT: 'xls_export',
  XLS_REPORT: 'xls_report',
  EXPORT_STATUS: 'export_status',
}

export const ACTION_FILTERS_ID = {
  ANOMALY: 'anomaly',
  GROUP: 'group',
  ACTION_TYPE: 'action-type',
  SOURCE: 'source',
  MANAGER: 'manager',
  LABEL: 'label',
  CATEGORY: 'category',
}

export const SEARCH_ACTIONS_URL: Readonly<Record<string, string>> = {
  LIST: '/v2/actions/search',
  GANTT: '/project/search',
}

export const ACTION_FILTER_OPTIONS_EMPTY: Readonly<GetActionFilterResponse> = {
  perimeters: [],
  priorities: [],
  statuses: [],
  managers: [],
  isAnomaly: [],
  actionType: [],
  source: [],
  groups: [],
  labels: [],
  categories: [],
}

export const SELECTED_ACTION_FILTERS_EMPTY: Readonly<ActionFilters> = {
  perimeters: [],
  priorities: [],
  groups: [],
  statuses: [],
  types: [],
  sources: [],
  withAnomaly: [],
  managers: [],
  labels: [],
  categories: [],
}

export const FILTER_DEFAULT_STATUSES: ActionStatus[] = [
  ActionStatus.ONGOING,
  ActionStatus.PLANNED,
  ActionStatus.STANDBY,
  ActionStatus.TO_PLAN,
]

export const FILTERS_NAME_MAPPING: Record<keyof ActionFilters, keyof GetActionFilterResponse> = {
  groups: 'groups',
  labels: 'labels',
  managers: 'managers',
  perimeters: 'perimeters',
  priorities: 'priorities',
  sources: 'source',
  statuses: 'statuses',
  types: 'actionType',
  withAnomaly: 'isAnomaly',
  categories: 'categories',
}

export const SHOULD_DISPLAY_CREATE_ACTION_BUTTON: InjectionKey<ComputedRef<boolean>> = Symbol(
  'shouldDisplayCreateActionButton'
)
export const HAS_SELECTED_FILTERS: InjectionKey<ComputedRef<boolean>> = Symbol('hasSelectedFilters')

export const FETCH_ACTIONS_DEBOUNCE_TIME = 300
